
import { memo, useCallback } from "react";
import { useAppDispatch } from "@/AppRedux/store/hooks";
import { requestHotelProfile } from "@/AppRedux/actions/hotelProfile";
import { getCurrentLanguage } from "./i18n.utils";

interface LanguagePickerProps {
  propcode?: string;
}

export const LanguagePicker = memo(function LanguagePicker({ propcode }: LanguagePickerProps) {
  const dispatch = useAppDispatch();

  const change = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
    const lang = e.target.value;
    (window as any).__setLocale?.(lang);
    if (propcode) {
      dispatch(requestHotelProfile(propcode));
    }
  }, [propcode, dispatch]);

  const current = getCurrentLanguage();

  return (
    <select
      onChange={change}
      defaultValue={current}
      style={{
        background: "#FFFFFF",
        color: "#000000",
        borderRadius: 8,
        border: '1px solid rgba(0,0,0,0.12)',
        padding: '2px 8px',
        height: 28,
      }}
    >
      <option value="en">English</option>
      <option value="th">Thai</option>
      <option value="zh">Chinese</option>
      <option value="ru">Russian</option>
      <option value="ko">Korean</option>
      <option value="ja">Japanese</option>
    </select>
  );
});
